import axios from "axios";
import Cookies from "js-cookie";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    const token = Cookies.get("aiorigin_website_security");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    } else {
      delete config.headers["Authorization"]; 
    }
    return config;
  },
  (err) => Promise.reject(err)
);

export default axiosClient;
